import React, { createContext, useEffect, useState } from "react";

export const RecommendationContext = createContext();

export const RecommendationProvider = ({ children }) => {
  const [recomData, setRecomData] = useState("asd");
  const [isRecommendationVisible, setRecommendationVisible] = useState(true);
  const [alerts, setAlerts] = useState([
    {
      createdTime: "24/05/2019",
      alertDesc: "Optimize production by adjusting Factor1",
    },
  ]);
  const [currentPage, setCurrentPage] = useState(null);
  const [currentRelationId, setCurrentRelationId] = useState(null);

  const updateAlertCriteria = (page, relationId) => {
    setCurrentPage(page);
    setCurrentRelationId(relationId);
  };

  const hideRecommendation = () => {
    setRecommendationVisible(false);
  };

  const showRecommendation = () => {
    setRecommendationVisible(true);
  };

  const contextValue = {
    recomData,
    isRecommendationVisible,
    hideRecommendation,
    showRecommendation,
    alerts,
    updateAlertCriteria,
  };

  return (
    <RecommendationContext.Provider value={contextValue}>
      {children}
    </RecommendationContext.Provider>
  );
};
